"use strict";
/**
 * FilterComponent
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var DropDownComponent_1 = __importDefault(require("../FormComponents/DropDownComponent"));
var commonTypes_1 = require("../../types/commonTypes");
var crudeActions = __importStar(require("../../../store/crude/crude.actions"));
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
var material_1 = require("@mui/material");
var FilterComponent = function (props) {
    var dispatch = react_redux_1.useDispatch();
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var crudeFilter = react_redux_1.useSelector(crude_selector_1.getCrudeFilter);
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var activeEntity = react_redux_1.useSelector(crude_selector_1.getActiveEntity);
    var loadFilterData = react_redux_1.useSelector(crude_selector_1.getLoadFilterData);
    var _a = react_1.useState(props.entity || activeEntity), entity = _a[0], setEntity = _a[1];
    var disabled = (props.dataViewType && props.dataViewType === commonTypes_1.DataViewType.referenceView)
        ? false
        : (dataDisplayMode === commonTypes_1.DataDisplayMode.edit);
    react_1.useEffect(function () {
        setEntity(props.entity || activeEntity);
    }, [props.entity, activeEntity]);
    var onChangeFilterValue = function (filter, value) {
        var _a, _b;
        var _c;
        if (entity) {
            var filterObject = __assign({}, (_c = storedTableFilterSettings[entity][props.treeviewLevel]) === null || _c === void 0 ? void 0 : _c.filter);
            if (value) {
                filterObject[filter] = value.key;
            }
            else {
                delete filterObject[filter];
            }
            var newSettings = __assign(__assign({}, storedTableFilterSettings[entity][props.treeviewLevel]), { filter: filterObject, page: 0 });
            var changeSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = (_b = {},
                _b[props.treeviewLevel || 0] = newSettings,
                _b), _a));
            if (props.onChangeFilter) {
                props.onChangeFilter(changeSettings);
            }
            else {
                dispatch(crudeActions.setShowCollapse(false));
                dispatch(crudeActions.setTableFilterSettings(changeSettings));
            }
        }
    };
    return (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: props.justifyContent || 'flex-start' } }, loadFilterData
        ? (react_1.default.createElement(material_1.Box, { sx: { width: '100%', marginTop: '16px' } },
            react_1.default.createElement(LinearProgress_1.default, { color: 'primary' })))
        : (react_1.default.createElement(react_1.default.Fragment, null, entity && crudeFilter && crudeFilter[entity] && crudeFilter[entity].map(function (filter) {
            var value = storedTableFilterSettings[entity][props.treeviewLevel].filter[filter.name];
            var enumValue = value ? filter.options.find(function (elem) { return elem.key === value; }) : undefined;
            return (react_1.default.createElement("div", { key: filter.name, style: { padding: '0 16px 16px 0' } },
                react_1.default.createElement(DropDownComponent_1.default, { description: filter.description, disabled: disabled, key: filter.name, name: filter.name, width: '250px', options: filter.options, label: filter.label, color: 'primary', size: 'small', value: enumValue, onChange: function (value) {
                        onChangeFilterValue(filter.name, value);
                    } })));
        })))));
};
exports.default = FilterComponent;
